import { createFileRoute } from "@tanstack/react-router";

import { HowItWorks } from "../components/trees/how-it-works";
import ImpactLevel from "../components/trees/impact-level";
import { PartnershipTreeNation } from "../components/trees/partnership-tree-nation";
import { PlantTreesTrack } from "../components/trees/plant-trees-track";

export const Route = createFileRoute("/trees")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex flex-col gap-8 mx-auto p-4 pb-12 bg-gradient-to-br from-[#2b7fff]/10 to-[#fe9a00]/10 w-full h-full">
      <div className="pb-4">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-[#2b7fff] to-[#fe9a00] bg-clip-text text-transparent">
          Plant Trees
        </h1>
        <p className="text-gray-500">
          Earning stars for a healthier lifestyle and a healthier planet.
        </p>
      </div>

      <PlantTreesTrack />

      <HowItWorks />

      <ImpactLevel />

      <PartnershipTreeNation
        imageUrl="/tree-nation.jpg"
        imageAlt="Tree-Nation Forest"
      />
    </div>
  );
}
